import { render, staticRenderFns } from "./SupervisionCard.vue?vue&type=template&id=2d55bae8&"
import script from "./SupervisionCard.vue?vue&type=script&lang=js&"
export * from "./SupervisionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports